import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-refund',
  templateUrl: './refund.component.html',
  styleUrls: ['./refund.component.scss']
})
export class RefundComponent implements OnInit {

  constructor(private title: Title) { }

  ngOnInit(): void {
    // this.title.setTitle(`Refund | Illusbook`);
  }

}
